window.addEventListener('load', function () {
	var element = jQuery(".bm-Footer  input[type='submit']");
	jQuery(element).addClass('btn btn-color1');
});
